@if (canManageLockout) {
  <mat-card class="lockout-card">
    <div class="lockout-head">
      <div class="lockout-title">
        <mat-icon aria-hidden="true">lock_clock</mat-icon>
        <h3>Schedule Day Lockout</h3>
      </div>
    </div>

    <p class="lockout-desc">Lock schedules and auto-fill free slots with promos.</p>

    @if (loadingStations) {
      <div class="lockout-skeleton" aria-hidden="true">
        <div class="skeleton-field"></div>
        <div class="skeleton-field"></div>
        <div class="skeleton-btn"></div>
      </div>
    } @else {
      <form [formGroup]="form" class="lockout-form">
        <div class="lockout-form-fields">
          @if (showStationDropdown) {
            <mat-form-field appearance="outline" class="lockout-field lockout-station-field" subscriptSizing="dynamic">
              <mat-label>Station</mat-label>
              <mat-select formControlName="stationId" (selectionChange)="onStationChange()">
                @for (s of manageableStations; track s.id) {
                  <mat-option [value]="s.id">{{ s.name }} ({{ s.call_sign }})</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field
            appearance="outline"
            class="lockout-field lockout-date-field"
            subscriptSizing="dynamic"
            (click)="openDatePicker()"
          >
            <mat-label>Lockout date</mat-label>
            <input
              matInput
              [matDatepicker]="lockPicker"
              formControlName="lockoutDate"
              [matDatepickerFilter]="lockoutDateFilter"
              [min]="minLockoutDate"
              readonly
              (click)="openDatePicker(); $event.stopPropagation()"
              [disabled]="loadingLockedDates || effectiveStationId == null || locking"
            />
            <mat-datepicker-toggle matIconSuffix [for]="lockPicker" (click)="$event.stopPropagation()"></mat-datepicker-toggle>
            <mat-datepicker #lockPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="lockout-actions">
          <button
            type="button"
            class="btn-primary lock-btn"
            (click)="lockDay()"
            [disabled]="
              locking ||
              loadingLockedDates ||
              form.invalid ||
              effectiveStationId == null ||
              isDateAlreadyLocked(form.get('lockoutDate')?.value)
            "
            [attr.aria-busy]="locking"
          >
            @if (locking) {
              <span class="btn-spinner" aria-hidden="true"></span>
              <span>Locking…</span>
            } @else {
              <mat-icon aria-hidden="true">lock</mat-icon>
              <span>Lock</span>
            }
          </button>
        </div>
      </form>

      @if (!loadingLockedDates && isDateAlreadyLocked(form.get('lockoutDate')?.value)) {
        <p class="lockout-warn" role="alert">This date is already locked.</p>
      }

      @if (loadingLockedDates && effectiveStationId != null) {
        <p class="lockout-status" aria-live="polite">Loading locked dates…</p>
      }

      <div class="locked-dates-section" aria-live="polite">
        @if (loadingLockedDates) {
          <div class="locked-skeleton">
            @for (i of [1,2,3,4]; track i) {
              <div class="skeleton-chip"></div>
            }
          </div>
        } @else if (upcomingLockedDates.length === 0) {
          <p class="locked-dates-hint empty">No upcoming locked dates for this station.</p>
        } @else {
          <div class="locked-dates-header">
            <p class="locked-dates-label">Upcoming locked dates</p>
            @if (hasMoreLockedDates) {
              <button type="button" class="see-full-link" (click)="openFullLockedList()">See full list</button>
            }
          </div>
          <div class="locked-chips">
            @for (d of previewLockedDates; track d) {
              <div class="locked-date-chip">
                <span class="locked-date-text">{{ d }}</span>
                <button
                  mat-icon-button
                  type="button"
                  class="chip-unlock-btn"
                  [attr.aria-label]="'Unlock ' + d"
                  [disabled]="unlockingDate !== null"
                  (click)="unlockDate(d, $event)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    }
  </mat-card>
}
